/**
 * Created by anthony on 7/7/14.
 */
var reportsModel = angular.module('reportsModel', ['baseModel']);
reportsModel.factory('ReportsModelFactory', function(ApplicationService, RestService, authServiceFactory, BaseModel){
    var ReportsModel = function(){
        var args = ['Reports'];
        BaseModel.apply(this, args);
        this.endpoint = args[0];
    }
    ReportsModel.prototype = new BaseModel();
    return ReportsModel;
});

reportsModel.service('ReportsModelService', function(ReportsModelFactory){
    var reportsModel = new ReportsModelFactory();
    return reportsModel;
});
